<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createAbsenceRequest" (change)="createAbsenceRequestChange()"
        (submit)="createAbsenceRequestSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"ABSENCE_REQUEST_CREATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0"
                    routerLink="/attendence/authorized-absence-request" *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"TYPE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="absenceType">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <!-- <option value="ma">{{"MA" | translate | titlecase }}</option>
                                    <option value="ua">{{"UA" | translate | titlecase }}</option>
                                    <option value="aa">{{"AA" | translate | titlecase }}</option> -->
                                    <option *ngFor="let field of absTypes" [ngValue]="field.id">
                                        {{
                                        (globals.lang == 'ar')? field?.attNameAr : field?.attNameEn
                                        }}
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAbsenceRequest.controls.absenceType.touched && createAbsenceRequest.controls.absenceType.invalid && createAbsenceRequest.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"STUDENT" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="student">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let field of students" [ngValue]="field.id">
                                        {{
                                        (globals.lang == 'ar')? field?.fullNameAr : field?.fullNameEn
                                        }}
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAbsenceRequest.controls.student.touched && createAbsenceRequest.controls.student.invalid && createAbsenceRequest.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"DATE_FROM" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="dateFrom">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAbsenceRequest.controls.dateFrom.touched && createAbsenceRequest.controls.dateFrom.invalid && createAbsenceRequest.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"DATE_TO" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="dateTo">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAbsenceRequest.controls.dateTo.touched && createAbsenceRequest.controls.dateTo.invalid && createAbsenceRequest.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="remarks">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAbsenceRequest.controls.remarks.touched && createAbsenceRequest.controls.remarks.invalid && createAbsenceRequest.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ATTACHMENT" | translate | titlecase }}</label>
                                <input type="file" class="form-control" formControlName="attachment"
                                (change)="changeFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAbsenceRequest.controls.attachment.touched && createAbsenceRequest.controls.attachment.invalid && createAbsenceRequest.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"STATUS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="status">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="accept">{{"ACCEPT" | translate | titlecase }}</option>
                                    <option value="rejected">{{"REJECTED" | translate | titlecase }}</option>
                                    <option value="under processing">{{"UNDER_PROCESSING" | translate | titlecase }}
                                    </option>
                                    <option value="draft">{{"DRAFT" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createAbsenceRequest.controls.status.touched && createAbsenceRequest.controls.status.invalid && createAbsenceRequest.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>